<template>
    <div>
        <PageTitle :title="$t('renovar_base.titulo')" class="strech" />
        <section>
            <b-container class="mt-4">
                <Stepper
                    :steps="steps"
                    ref="stepper"
                >
                    <template #paso0>
                        <section class="padding-vertical-content white-content right-background">
                            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + manager.bg2_url + ")"'></div>
                            <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row justify-content-start">
                                            <div class="col-12 col-lg-6">
                                                <div v-if="loading">
                                                    <LoaderComponent/>
                                                </div>
                                                <h2 class="m-0 mt-5 h2 text-uppercase">{{ $t('renovar_base.renueva_base', {base: 'Cantera'}) }}</h2>
                                                <div class="subtitle h3 light mb-3 mb-lg-5"> {{ $t('renovar_base.temporada', { temporada: lista_abonados.nombre }) }}</div>

                                                <BuscarBaseComponent :front="true" :base="base_search" :error="error" :paso_activo="true"  @terminado="buscarBase"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </template>
                    <template #paso1="{ changeStep }">

                        <PasoUnoComponent
                            :esMovil="esMovil"
                            :base="base"
                            :codigo_invitacion="codigo_invitacion"
                            @volver="() => { changeStep(true); }"
                            :fields="fields?.filter(field => field.pivot.deportista === true)"
                            @terminado="(data) => { actualizarBase(data); addNewStep(data['categoria_base']); changeStep(); }"
                            :active="true"
                        />
                    </template>
                    <template #paso2="{ changeStep }">
                        <PasoDosComponent
                            :esMovil="esMovil"
                            :base="base"
                            :fields="fields?.filter(field => field.pivot.representante === true)"
                            @terminado="(data) => { actualizarBase(data); changeStep(); }"
                            @volver="() => { changeStep(true); }"
                        />
                    </template>

                    <template #paso3="{ changeStep }">
                        <PasoTresComponent
                            :esMovil="esMovil"
                            :base="base"
                            @terminado="(data) => { actualizarBase(data); changeStep(); }"
                            @volver="() => { changeStep(true); }"
                        />
                    </template>

                    <template #paso4="{ changeStep }">
                        <PasoCuatroComponent
                            :esMovil="esMovil"
                            :base="base"
                            @terminado="(data) => { actualizarBase(data); changeStep(); }"
                            @volver="() => { changeStep(true); }"
                        />
                    </template>

                    <template #paso5="{ changeStep }">
                        <PasoCincoComponent
                            v-if="base.categoria_base.tiene_indumentarias"
                            :esMovil="esMovil"
                            :base="base"
                            @terminado="(indumentarias, data) => { terminarPasoCinco(indumentarias, data); changeStep(); }"
                            @volver="() => { changeStep(true); }"
                        />
                    </template>

                    <template #paso6="{ changeStep }">
                        <PasoSeisComponent
                            :esMovil="esMovil"
                            :base="base"
                            :paso_activo="!pago_paycomet"
                            @terminado="(data) => { actualizarBase(data); changeStep() }"
                            @volver="() => { changeStep(true); }"
                        />
                    </template>

                    <template #pago>
                        <ProcesarCompraComponent :base="base" />
                    </template>
                </Stepper>
            </b-container>
        </section>
    </div>
</template>

<script>
    import BuscarBaseComponent from '@/components/frontend/bases/renovar/BuscarBaseComponent';
    import PasoUnoComponent from "@/components/frontend/bases/PasoUnoComponent";
    import PasoDosComponent from "@/components/frontend/bases/PasoDosComponent";
    import PasoTresComponent from "@/components/frontend/bases/PasoTresComponent";
    import PasoCuatroComponent from "@/components/frontend/bases/PasoCuatroComponent";
    import PasoCincoComponent from "@/components/frontend/bases/PasoCincoComponent";
    import PasoSeisComponent from "@/components/frontend/bases/PasoSeisComponent";
    import ProcesarCompraComponent from "@/components/frontend/bases/ProcesarCompraComponent";
    import Stepper from '@/components/frontend/events/compra/components/Stepper';
    import PageTitle from "@/components/frontend/shared/PageTitle";

    export default {
        data() {
            return {
                base_search: {
                    dni: null,
                },
                base: null,
                error: false,
                loading: false,
                pago_paycomet: false,
                codigo_invitacion: null,
                esMovil: false,
                tieneIndumentarias: false
            }
        },
        created() {
            if(!this.manager.futbol_base || this.manager.activar_compra_por_invitacion_bases && localStorage.getItem('codigo_invitacion') == null) {
                this.$router.push({ name: 'front.home'});
            }
            if (this.manager.activar_compra_por_invitacion_bases) {
                this.codigo_invitacion  = localStorage.getItem('codigo_invitacion');
                localStorage.removeItem('codigo_invitacion');
            }
            if (this.teatro.tipo_tpv === 2) {
                this.steps.push({ label: "Datos de pago", slot: "pago" });
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            fields() {
                return this.lista_abonados.fields_deportistas;
            },
            steps() {
                const steps = [
                    { label: this.$t('renovar_base.dni_deportista'), slot: 'paso0' },
                    { label: this.$t('bases.datos_deportista'), slot: 'paso1' },
                    { label: this.$t('bases.datos_responsables'), slot: 'paso2' },
                    { label: this.$t('bases.documentacion'), slot: 'paso3' },
                    { label: this.$t('bases.foto_de_perfil'), slot: 'paso4' },
                ];

                if (this.tieneIndumentarias) {
                    steps.push({ label: this.$t('bases.indumentarias'), slot: 'paso5' });
                }

                steps.push({ label: this.$t('bases.resumen_compra'), slot: 'paso6' });

                if (this.teatro?.tipo_tpv === 2) {
                    steps.push({ label: this.$t('bases.pago'), slot: 'pago' });
                }

                return steps;
            }

        },
        methods: {
            buscarBase(updateBase) {
                if(updateBase){
                    this.base_search = updateBase;
                }

                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.base_search.dni
                    },
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bases.buscar'), params).then(res => {
                    this.base = res.data.base;
                    this.base.fields_deportista = {};
                    this.base.fields_responsable_1 = {};
                    this.base.fields_responsable_2 = {};
                    this.$refs.stepper.changeStep();
                }).catch(error => {
                    this.error = error.response.data.message;
                }).finally(() => {
                    this.loading = false
                });
            },
            actualizarBase(data) {
                this.base = { ...data };
            },
            addNewStep(categoria) {
                this.tieneIndumentarias = !!categoria?.tiene_indumentarias;
            },
            onResize() {
                this.esMovil = window.innerWidth < 768
            },
            terminarPasoCinco(indumentariasElegidas, data) {
                if (indumentariasElegidas) {
                    this.base.categoria_base.indumentariasElegidas = indumentariasElegidas;
                }

                this.actualizarBase(data);
            },
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        components: {
            BuscarBaseComponent,
            PasoUnoComponent,
            PasoDosComponent,
            PasoTresComponent,
            PasoCuatroComponent,
            PasoCincoComponent,
            PasoSeisComponent,
            ProcesarCompraComponent,
            PageTitle,
            Stepper
        }
    }
</script>
